import { AuthProvider, useAuth } from "./context/AuthContext";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

import { dashboardRoutes } from "./routeConfig";
import Dashboard from "./pages/dashboard";
import Error404 from "./pages/404";
import LoginPage from "./pages/login_page";

const ProtectedRoute: React.FC<{
     component: React.ComponentType<any>;
     id: string;
     menuName: string;
     isHoc?: boolean;
     hocWrapper?: (Component: React.ComponentType<any>) => React.ComponentType<any>;
}> = ({ component: Component, id, menuName, isHoc, hocWrapper }) => {
     const { isAuthenticated, isLoading, userData } = useAuth();
     const navigate = useNavigate();
     const [isAuthorized, setIsAuthorized] = useState(false);

     useEffect(() => {
          if (!isLoading) {
               if (!isAuthenticated) {
                    navigate("/login_page");
               } else if (userData?.users === 'edp') {
                    setIsAuthorized(true);
               } else if (!userData || !userData.menu_otoritas) {
                    navigate("/dashboard/404");
               } else {
                    const allowedIds = new Set(
                         userData.menu_otoritas
                              .split(";")
                              .map((s) => s.trim())
                              .filter(Boolean),
                    );
                    if (!allowedIds.has(id)) {
                         navigate("/dashboard/404");
                    } else {
                         setIsAuthorized(true);
                    }
               }
          }
     }, [isAuthenticated, isLoading, userData, id, navigate]);

     if (isLoading || !isAuthorized) {
          return null;
     }

     return isHoc && hocWrapper ? React.createElement(hocWrapper(Component)) : <Component />;
};

function App() {
     return (
          <AuthProvider>
               <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route
                         path="/dashboard"
                         element={
                              <div className="dashboard-wrapper">
                                   <Dashboard {...({} as any)} /> 
                              </div>
                         }>
                         <Route
                              path="404"
                              element={
                                   <div className="error404-wrapper" aria-label="Error 404">
                                        <Error404 />
                                   </div>
                              }
                         />
                         {dashboardRoutes.map((route) => (
                              <Route
                                   key={route.id}
                                   path={route.path}
                                   element={
                                        <div
                                             className={`${route.wrapperClass}-wrapper`}
                                             aria-label={route.menuName}>
                                             <ProtectedRoute
                                                  component={route.component}
                                                  id={route.id}
                                                  menuName={route.menuName}
                                                  isHoc={route.isHoc}
                                                  hocWrapper={route.hocWrapper}
                                             />
                                        </div>
                                   }
                                   id={route.id}
                              />
                         ))}
                    </Route>
                    <Route
                         path="/login_page"
                         element={
                              <div className="login_page-wrapper">
                                   <LoginPage />
                              </div>
                         }
                    />
               </Routes>
          </AuthProvider>
     );
}

export default App;
